import React from 'react'
import { Box, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import useTrustPilot from '../../hooks/useTrustPilot'
import SvgTrustPilotLogo from '../../images/trust-pilot-logo.inline.svg'

const ReviewCountCard: React.FC = () => {
  const { classes } = useStyles()
  const trustPilot = useTrustPilot()
  const { t } = useTranslation()

  if (!trustPilot) {
    return null
  }

  return (
    <Box
      className={classes.root}
      component="a"
      // @ts-ignore
      href={trustPilot.links.profileUrl}
    >
      <Typography className={classes.count} component="h6">
        {trustPilot.businessUnit.numberOfReviews.total}
      </Typography>
      <Box>
        <Typography className={classes.reviewsOn}>
          {t('trustpilot.reviewsOn')}
        </Typography>
        <SvgTrustPilotLogo alt="TrustPilot" />
      </Box>
    </Box>
  )
}

const useStyles = makeStyles()((theme) => ({
  root: {
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    borderRadius: '6px',
    color: theme.palette.text.primary,
    display: 'flex',
    justifyContent: 'space-between',
    padding: '.63em',
    textDecoration: 'none',
  },
  count: {
    fontSize: '3em',
    fontWeight: 'bold',
    lineHeight: 'normal',
    marginRight: '.25em',
  },
  reviewsOn: {
    fontSize: '0.8125em',
  },
}))

export default ReviewCountCard
